module.exports = __webpack_public_path__ + "img/aeat-791-logo.85607097.png";